import { unitTranslation } from "@/common/constants/unitStrategies.contants";
import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterSheet from "../DashboardFilterSheet";

const unitForConsumptionOptions = strategyToOptions(unitTranslation);

const DashboardFilterEquipmentCategoryUnitForConsumptionSheet = ({ filters, setFilters }: DashboardFilterProps) => {
  return (
    <DashboardFilterSheet
      filterKey={DashboardFilters.EquipmentCategoryUnitForConsumption}
      options={unitForConsumptionOptions}
      filters={filters}
      setFilters={setFilters}
    />
  );
}

export default DashboardFilterEquipmentCategoryUnitForConsumptionSheet;
